module.exports = __webpack_public_path__ + "409d640f9227641cddc47dc9d6fd2855.svg";